import styled from 'styled-components'

export const Banner = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  margin-top: 50px;
  padding: 16px;
  border: 1px solid #b6dbfb;
  border-radius: 8px;
  background: #e7f3fe;

  svg {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    margin: 4px;
    font-size: 14px;
    color: #002a6d;
  }
`

export const BannerText = styled.p`
  flex: 1;
  min-width: 0;
  margin: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  word-break: break-word;
`

export const BannerStrong = styled.strong`
  font-weight: 700;
`
